import { TAxiosResponse } from "types";
import { axiosInstance } from "./axiosInstance";
import { DEFAULT_PAGE_SIZE } from "@constants/common";
import { TCheckCompanyExistReq, TCompanyUpdateReq } from "@models/company";
import {
  TCompanyDetailRes,
  TGetCompanyParam,
  TRegistrationCompanyReq,
  TSearchCompanyParam,
  TSearchCompanyResponse,
} from "types/types";
import { API_URL } from "@redux/rootConstant";

const companyApi = {
  getCompanies: async (payload: TGetCompanyParam) => {
    const url = API_URL.MASTER_DATA.GET_COMPANY;
    const response: TAxiosResponse<TCompanyDetailRes[]> =
      await axiosInstance.get(url, {
        params: {
          storeId: payload.storeId,
        },
      });
    return response;
  },

  // getCompaniesByCode: async (payload: TListCompanyReq) => {
  //   const _pageIndex = payload.pageIndex ? payload.pageIndex : 1;
  //   const _payload: Omit<TListCompanyReq, "pageIndex"> = {
  //     companyCode: payload.companyCode || "",
  //   };
  //   const url = `/Company/search?CompanyCode=${_payload.companyCode}&PageIndex=${_pageIndex}&PageSize=${DEFAULT_PAGE_SIZE}`;

  //   const response: TAxiosResponse<TListCompanyRes[], TCommonError> =
  //     await axiosInstance.get(url);
  //   return response;
  // },

  getDetailCompany: async (payload: string) => {
    const url = `${API_URL.MASTER_DATA.GET_COMPANY}/${payload}`;
    const response: TAxiosResponse<TCompanyDetailRes> = await axiosInstance.get(
      url
    );
    return response;
  },

  searchCompany: async (payload: TSearchCompanyParam) => {
    const page = payload.page ? payload.page : 1;
    const response: TAxiosResponse<TSearchCompanyResponse> =
      await axiosInstance.get(API_URL.SEARCH_COMPANY, {
        params: {
          companyId: payload.companyId,
          page: page,
          pageSize: DEFAULT_PAGE_SIZE,
        },
      });
    return response;
  },

  registrationCompany: async (payload: TRegistrationCompanyReq) => {
    const url = API_URL.REGISTRATION_COMPANY;
    const response: TAxiosResponse<TCompanyDetailRes> =
      await axiosInstance.post(url, payload);
    return response;
  },

  deleteCompany: async (payload: string) => {
    const url = `${API_URL.DELETE_COMPANY}/${payload}`;
    const response: TAxiosResponse<any> = await axiosInstance.delete(url);
    return response;
  },

  updateCompany: async (payload: TCompanyUpdateReq) => {
    const url = API_URL.UPDATE_COMPANY;
    const response: TAxiosResponse<TCompanyUpdateReq> = await axiosInstance.put(
      url,
      payload
    );
    return response;
  },

  checkCompanyExist: async (payload: TCheckCompanyExistReq) => {
    const url = API_URL.CHECK_EXIST_COMPANY;
    const response: TAxiosResponse<any> = await axiosInstance.post(
      url,
      payload
    );
    return response;
  },
};

export { companyApi };
